import React, { useContext, lazy } from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'

import { DetectDeviceContext } from 'wsc/components/context/DetectDeviceProvider'
import { MEDIA, PAGE_WIDTHS, PADDINGS } from '../utils/styles'

// import PreviewSiteBanner from 'wsc/components/PreviewSiteBanner'
import NavbarMobile from './navbar/NavbarMobile'
import NavbarDesktop from './navbar/NavbarDesktop'
// import SubscribePopup from './SubscribePopup'

import ReactComponentLoader from 'wsc/components/ReactComponentLoader'
import AdSlot from 'wsc/components/AdSlot'

export const LAYOUT_MINWIDTH = 320

const Footer = lazy(() => import('./footer/Footer'))

const ScWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  ${({ bgColor }) => bgColor && `background-color: ${bgColor};`}
  min-width: ${LAYOUT_MINWIDTH}px;
  min-height: 100vh;
 
  .takeover-active & {
    background-color: ${({ bgColor }) => (bgColor ? bgColor : 'white')};
    padding: 0 1em;
    margin: 0 auto;
    ${MEDIA.TABLET`width: calc(${PAGE_WIDTHS.TABLET}px + 40px);`}
    // layout width for Desktop when takeover active should not more than 1100px.
    ${MEDIA.DESKTOP`width: calc(${PAGE_WIDTHS.DESKTOP - 28}px + 40px);`}
  }
`
const ScContainer = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
  flex-grow: 1; // for making Footer is always on bottom

  ${props =>
    props.contentVerticalPadding &&
    `padding-top: ${props.contentVerticalPadding}; padding-bottom: ${props.contentVerticalPadding};`}

  ${props => props.contentDisplayStyle && `display: ${props.contentDisplayStyle};`}

  ${props => props.contentItemAlignment && `align-items: ${props.contentItemAlignment};`}
  
  ${MEDIA.MOBILE`
    padding-left: ${PADDINGS.DEFAULT.MOBILE}px;
    padding-right: ${PADDINGS.DEFAULT.MOBILE}px;`}

  ${MEDIA.TABLET`width: ${PAGE_WIDTHS.TABLET}px;`} 
  ${MEDIA.DESKTOP`
      width: ${PAGE_WIDTHS.DESKTOP}px;
      .takeover-active & {
        width: ${PAGE_WIDTHS.DESKTOP - 28}px;
      }
    `}

  ${props => props.fullscreen && MEDIA.MOBILE`padding: 0;`}
  ${props => props.fullscreen && MEDIA.TABLET`width: 100%;`}
  ${props => props.fullscreen && MEDIA.DESKTOP`width: 100%;`}
`
/*----------------------------------------------------------------------------------
 *  RENDER PHASE
 *---------------------------------------------------------------------------------*/

const Layout = props => {
  const {
    children,
    contentVerticalPadding,
    fullscreen,
    contentDisplayStyle,
    contentItemAlignment,
    bgColor,
  } = props
  const { isDesktop } = useContext(DetectDeviceContext)

  return (
    <>
      <AdSlot type="flex_leaderboard" tagless lazy={false} />
      {/* <PreviewSiteBanner /> */}
      {isDesktop ? <NavbarDesktop /> : <NavbarMobile />}
      <ScWrapper bgColor={bgColor}>
        <ScContainer
          fullscreen={fullscreen}
          contentVerticalPadding={contentVerticalPadding}
          contentDisplayStyle={contentDisplayStyle}
          contentItemAlignment={contentItemAlignment}
        >
          {children}
        </ScContainer>
        {/* <SubscribePopup key={`popup-${window.location.pathname}`} /> */}
        <ReactComponentLoader>
          <Footer />
        </ReactComponentLoader>
      </ScWrapper>
    </>
  )
}

Layout.propTypes = {
  contentVerticalPadding: PropTypes.string,
  children: PropTypes.node.isRequired,
  fullscreen: PropTypes.bool,
  contentDisplayStyle: PropTypes.string,
  contentItemAlignment: PropTypes.string,
  bgColor: PropTypes.string,
}

Layout.defaultProps = {
  fullscreen: false,
  contentVerticalPadding: null,
  contentDisplayStyle: null,
  contentItemAlignment: null,
  bgColor: null,
}

export default Layout
